/**
 * Shown while a route guard waits for `GET /api/auth/me`. Deliberately plain:
 * it appears for a few hundred milliseconds on a cold load, and anything with a
 * layout of its own would flash against the shell that replaces it.
 */
export function ShellSpinner() {
  return (
    <div className="d-flex align-items-center justify-content-center w-100 py-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading</span>
      </div>
    </div>
  );
}
